import { useEffect, useRef } from "react";
import { capture } from "./posthog";

// Fires `event` when the tab is closed/hidden-for-unload while the flow is still open.
export function useAbandonTracker(event, getProps) {
  const open = useRef(true);
  const props = useRef(getProps);
  props.current = getProps;
  useEffect(() => {
    const onHide = () => { if (open.current) capture(event, props.current() || {}, { transport: "sendBeacon" }); };
    window.addEventListener("pagehide", onHide);
    return () => window.removeEventListener("pagehide", onHide);
  }, [event]);
  return () => { open.current = false; };
}
